// extracted by mini-css-extract-plugin
export default {"container":"ExplanationBlock_container__W1h8i","title":"ExplanationBlock_title__rKoZN","desct":"ExplanationBlock_desct__qFxI8"};